import { environmentInfo } from '@ms-cloudpack/environment';
import { PerfMarkerCliEntry } from '../performance/markers.js';

export function getCliStartTime(): number {
  const marks = performance.getEntriesByName(PerfMarkerCliEntry, 'mark');
  if (!marks.length) {
    if (environmentInfo.isJest) {
      return Date.now();
    }
    throw new Error(`${PerfMarkerCliEntry} marker not found`);
  }
  return marks[0].startTime;
}
